export default function Products() {
  const products = [
    {
      name: 'Batako',
      description: 'Batako berkualitas tinggi dengan ketepatan ukuran dan kekuatan optimal. Cocok untuk dinding rumah, ruko, dan bangunan komersial. Tersedia dalam berbagai ukuran standar dengan harga kompetitif.',
      icon: 'ri-building-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/5873b713d1fc4c9e835af752a9412950.jpeg',
      price: 'Rp 3.000'
    },
    {
      name: 'Paving Block',
      description: 'Paving block dengan berbagai motif dan warna untuk area parkir, taman, trotoar, dan halaman. Kuat menahan beban kendaraan dengan permukaan anti-slip dan mudah perawatan.',
      icon: 'ri-road-map-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/27dd9cbca90beab2d594783dfaa8b428.jpeg',
      price: 'Rp 5.000'
    },
    {
      name: 'Roster Nako 15x25',
      description: 'Roster beton dengan desain ventilasi klasik ukuran 15x25 cm. Memberikan sirkulasi udara optimal sekaligus mempercantik tampilan bangunan dengan motif yang elegan.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster 2 Muka Miring',
      description: 'Roster dengan desain 2 muka miring yang modern dan fungsional. Cocok untuk ventilasi dinding dengan tampilan yang lebih dinamis dan kontemporer.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Anyam',
      description: 'Roster dengan motif anyam yang artistik dan unik. Memberikan kesan tradisional modern pada bangunan dengan sirkulasi udara yang baik.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Bintang Besar',
      description: 'Roster dengan motif bintang besar yang menawan. Desain yang eye-catching untuk memberikan aksen dekoratif pada dinding bangunan.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Bubble',
      description: 'Roster dengan motif bubble atau gelembung yang playful dan modern. Cocok untuk bangunan dengan konsep desain yang fun dan kreatif.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Cacing',
      description: 'Roster dengan motif cacing yang unik dan berbeda. Memberikan tampilan yang distinctive pada ventilasi bangunan Anda.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Donat Besar',
      description: 'Roster dengan motif donat besar yang simple namun elegan. Desain bulat yang memberikan kesan modern dan minimalis.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Donat Kecil',
      description: 'Roster dengan motif donat kecil yang rapi dan teratur. Cocok untuk ventilasi dengan tampilan yang lebih detail dan halus.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster LBL/K',
      description: 'Roster LBL/K dengan desain geometris yang modern. Memberikan ventilasi optimal dengan tampilan yang stylish dan kontemporer.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Kincir',
      description: 'Roster dengan motif kincir yang dinamis dan menarik. Desain yang memberikan kesan movement pada dinding bangunan.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster LC/Digital',
      description: 'Roster dengan motif digital yang modern dan futuristik. Cocok untuk bangunan dengan konsep desain kontemporer.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Minimalis/Kriptyek',
      description: 'Roster dengan desain minimalis yang clean dan elegan. Perfect untuk bangunan modern dengan konsep simple dan sophisticated.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 10.000'
    },
    {
      name: 'Roster LBL4',
      description: 'Roster LBL4 dengan desain kotak-kotak yang rapi. Memberikan ventilasi maksimal dengan tampilan yang terstruktur.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster LBS',
      description: 'Roster LBS dengan motif segitiga yang sharp dan modern. Desain yang memberikan kesan tegas dan contemporary.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Pilin',
      description: 'Roster dengan motif pilin yang artistik dan unik. Memberikan kesan tradisional dengan sentuhan modern pada bangunan.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Plong 20x20',
      description: 'Roster plong ukuran 20x20 cm dengan desain simple dan fungsional. Cocok untuk berbagai jenis bangunan.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Shadow',
      description: 'Roster dengan desain shadow yang menciptakan efek bayangan menarik. Memberikan dimensi visual yang unik pada dinding.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Wafles',
      description: 'Roster dengan motif wafles yang unik dan playful. Desain yang fun namun tetap fungsional untuk ventilasi.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster X Panah',
      description: 'Roster dengan motif X dan panah yang bold dan striking. Memberikan statement yang kuat pada desain bangunan.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Z',
      description: 'Roster dengan motif Z yang modern dan dinamis. Desain yang memberikan kesan energik pada bangunan.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Roster Nako LB 1',
      description: 'Roster Nako LB 1 dengan desain klasik yang timeless. Cocok untuk berbagai style bangunan dari tradisional hingga modern.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/94312656467fda7d678ab75ed03699ab.jpeg',
      price: 'Rp 7.000'
    },
    {
      name: 'Grass Block',
      description: 'Grass block untuk area parkir ramah lingkungan, taman, dan halaman. Memungkinkan pertumbuhan rumput sambil menahan beban kendaraan. Solusi estetis yang mengurangi genangan air.',
      icon: 'ri-plant-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/bd139f3616b27b5af1484493cb44bab1.jpeg'
    },
    {
      name: 'Bis Beton Uk.20',
      description: 'Bis beton ukuran 20 untuk saluran air dan drainase. Kuat, tahan lama, dan mudah dipasang. Cocok untuk sistem drainase rumah, perumahan, dan area komersial.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/d676042fcee7ef2548cba822e93f1695.jpeg',
      price: 'Rp 50.000'
    },
    {
      name: 'Bis Beton Uk.30',
      description: 'Bis beton ukuran 30 untuk saluran air berkapasitas sedang. Ideal untuk drainase jalan, perumahan, dan area industri dengan aliran air yang lebih besar.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/d676042fcee7ef2548cba822e93f1695.jpeg',
      price: 'Rp 65.000'
    },
    {
      name: 'Bis Beton Uk.40',
      description: 'Bis beton ukuran 40 untuk saluran air berkapasitas besar. Sangat kuat menahan beban dan aliran air deras. Cocok untuk drainase jalan raya dan area industri.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/d676042fcee7ef2548cba822e93f1695.jpeg',
      price: 'Rp 85.000'
    },
    {
      name: 'Bis Beton Uk.60',
      description: 'Bis beton ukuran 60 untuk sistem drainase besar. Kuat dan tahan lama untuk menampung volume air yang sangat besar. Ideal untuk proyek infrastruktur.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/d676042fcee7ef2548cba822e93f1695.jpeg',
      price: 'Rp 85.000'
    },
    {
      name: 'Bis Beton Uk.80',
      description: 'Bis beton ukuran 80 untuk drainase skala besar. Sangat kuat dan kokoh untuk proyek infrastruktur jalan raya, perumahan besar, dan kawasan industri.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/d676042fcee7ef2548cba822e93f1695.jpeg',
      price: 'Rp 120.000'
    },
    {
      name: 'Bis Beton Paron Uk.30',
      description: 'Bis beton paron ukuran 30 dengan bentuk setengah lingkaran untuk saluran air terbuka. Mudah dipasang dan perawatan, cocok untuk drainase taman dan area terbuka.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/d676042fcee7ef2548cba822e93f1695.jpeg',
      price: 'Rp 45.000'
    },
    {
      name: 'Bis Beton Paron Uk.20',
      description: 'Bis beton paron ukuran 20 untuk saluran air kecil. Bentuk setengah lingkaran memudahkan aliran air dan pembersihan. Ideal untuk drainase rumah dan taman.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/d676042fcee7ef2548cba822e93f1695.jpeg',
      price: 'Rp 35.000'
    },
    {
      name: 'Produk Beton Pracetak Lainnya',
      description: 'Kami juga memproduksi berbagai produk beton pracetak custom sesuai kebutuhan proyek Anda seperti kanstin dan produk khusus lainnya dengan kualitas terjamin.',
      icon: 'ri-stack-line',
      image: 'https://public.readdy.ai/ai/img_res/3685222f57cfc7dd0b114881118fd8f5.jpg'
    }
  ];

  return (
    <section id="products" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Produk <span className="text-orange-600">Kami</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Berbagai pilihan material bangunan berkualitas tinggi untuk mendukung kesuksesan proyek konstruksi Anda
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center shadow-lg">
                  <i className={`${product.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-xl font-bold text-gray-900">{product.name}</h3>
                  {product.price && (
                    <span className="text-orange-600 font-bold text-sm whitespace-nowrap ml-2">{product.price}</span>
                  )}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">{product.description}</p>
                <a 
                  href="https://wa.me/6285642080427"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-4 text-orange-600 font-semibold text-sm hover:text-orange-700 transition-colors whitespace-nowrap"
                >
                  Tanya Harga
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="https://wa.me/6285642080427"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-orange-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-orange-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Konsultasi Gratis
          </a>
        </div>
      </div>
    </section>
  );
}